
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8565"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8565"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3Dw4r", function(module, exports) {

$parcel$export(module.exports, "register", () => $2a5de426b19a88a4$export$6503ec6e8aabbaf, (v) => $2a5de426b19a88a4$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $2a5de426b19a88a4$export$f7ad0328861e2f03, (v) => $2a5de426b19a88a4$export$f7ad0328861e2f03 = v);
var $2a5de426b19a88a4$export$6503ec6e8aabbaf;
var $2a5de426b19a88a4$export$f7ad0328861e2f03;
"use strict";
var $2a5de426b19a88a4$var$mapping = new Map();
function $2a5de426b19a88a4$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2a5de426b19a88a4$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2a5de426b19a88a4$var$resolve(id) {
    var resolved = $2a5de426b19a88a4$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2a5de426b19a88a4$export$6503ec6e8aabbaf = $2a5de426b19a88a4$var$register;
$2a5de426b19a88a4$export$f7ad0328861e2f03 = $2a5de426b19a88a4$var$resolve;

});

parcelRegister("dv4VP", function(module, exports) {

$parcel$export(module.exports, "FirstLoginCampaign", () => $75c71c4473e55e4a$export$c4fca78e1c1a4efd);
class $75c71c4473e55e4a$export$c4fca78e1c1a4efd {
    constructor(strategy){
        this.strategy = strategy;
    }
    init() {
        try {
            this.strategy.run();
        } catch (error) {
            console.error(error);
        }
    }
    setStrategy(strategy) {
        this.strategy = strategy;
    }
}
// Safari 16 doesn't like the static field syntax, and is still within our supported browsers.
// We can declare the static _type_ above, for TS reasons, but must assing the value in the
// ways of our ancestors.
$75c71c4473e55e4a$export$c4fca78e1c1a4efd.cookieName = "__decodable_first_login_campaign_completed";

});

parcelRegister("bBjqw", function(module, exports) {

$parcel$export(module.exports, "WriteUtmCookiesFromURLSearchParams", () => $d6ae3806ac0c8583$export$f8da7383acb518b4);
$parcel$export(module.exports, "SendUtmDataToHubSpot", () => $d6ae3806ac0c8583$export$73854c667588e6fe);

var $dv4VP = parcelRequire("dv4VP");

var $fcs8u = parcelRequire("fcs8u");

var $jegJ8 = parcelRequire("jegJ8");
class $d6ae3806ac0c8583$export$f8da7383acb518b4 {
    run() {
        const utmMap = this.getUtmMap(new URLSearchParams(window.location.search));
        const hasAnyUtmParams = Object.values(utmMap).some((v)=>!!v);
        if (!hasAnyUtmParams) return;
        (0, $jegJ8.UTM_KEYS).forEach((key)=>{
            if (utmMap[key]) this.cookieManager.createCookie({
                name: `__decodable_${key}`,
                value: utmMap[key],
                days: 1
            });
        });
    }
    getUtmMap(queryParams) {
        const params = (0, $jegJ8.UTM_KEYS).reduce((acc, curr)=>{
            acc[curr] = queryParams.get(curr);
            return acc;
        }, {});
        return params;
    }
    constructor(){
        this.cookieManager = new (0, $fcs8u.CookieManager)();
    }
}
class $d6ae3806ac0c8583$export$73854c667588e6fe {
    constructor(email){
        this.email = email;
        this.cookieManager = new (0, $fcs8u.CookieManager)();
    }
    run() {
        // The user has completed the campaign, but may have refreshed the page.
        if (this.cookieManager.readCookie((0, $dv4VP.FirstLoginCampaign).cookieName)) return;
        const fields = this.getHubSpotFields();
        const headers = new Headers();
        headers.append("content-type", "application/json");
        fetch("https://api.hsforms.com/submissions/v3/integration/submit/8792459/af2a1e9a-51b2-430c-a8ac-b40c5f6f5a2f", {
            method: "POST",
            headers: headers,
            body: JSON.stringify({
                fields: fields,
                context: {
                    pageUri: location.toString(),
                    pageName: document.title,
                    hutk: this.cookieManager.readCookie("hubspotutk")
                }
            })
        }).then(()=>{
            this.cookieManager.createCookie({
                name: (0, $dv4VP.FirstLoginCampaign).cookieName,
                value: new Date().toUTCString(),
                days: 365
            });
        }).catch(console.error);
    }
    getHubSpotFields() {
        return (0, $jegJ8.UTM_KEYS).reduce((acc, curr)=>{
            const cookieKey = `__decodable_${curr}`;
            const value = this.cookieManager.readCookie(cookieKey);
            if (value) {
                acc.push({
                    objectTypeId: "0-1",
                    name: curr,
                    value: value
                });
                this.cookieManager.eraseCookie(cookieKey);
            }
            return acc;
        }, [
            {
                objectTypeId: "0-1",
                name: "email",
                value: this.email
            }
        ]);
    }
}

});
parcelRegister("fcs8u", function(module, exports) {

$parcel$export(module.exports, "CookieManager", () => $08ec96f87a7283b6$export$c0f66b9778462a6f);
class $08ec96f87a7283b6$export$c0f66b9778462a6f {
    createCookie(args) {
        const expires = this.getExpiryDate(args.days);
        const cookie = `${args.name}=${args.value}; expires=${expires}; domain=${this.getHost()}; path=/; samesite=lax`;
        document.cookie = cookie;
    }
    readCookie(name) {
        const key = `${name}=`;
        const cookies = document.cookie.split(";").map((value)=>value.trim());
        for(let i = 0; i < cookies.length; i++){
            const cookie = cookies[i];
            const cookieSubstringKeyLength = cookie.substring(0, key.length);
            if (cookieSubstringKeyLength === key) return cookie.substring(key.length);
        }
        return "";
    }
    eraseCookie(name) {
        this.createCookie({
            name: name,
            value: "",
            days: -1
        });
    }
    getExpiryDate(days) {
        const daysMs = days * 86400000;
        const date = new Date();
        date.setTime(date.getTime() + daysMs);
        return date.toUTCString();
    }
    getHost() {
        const hostname = window.location.hostname.split(".").reverse();
        if (hostname[0] && hostname[1]) return `${hostname[1]}.${hostname[0]}`;
        return "";
    }
}

});

parcelRegister("jegJ8", function(module, exports) {

$parcel$export(module.exports, "UTM_KEYS", () => $4960359b1b7bf7c2$export$eb4368b669cabf3d);
const $4960359b1b7bf7c2$export$eb4368b669cabf3d = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "gclid",
    "gaid"
];

});


parcelRegister("c1A2z", function(module, exports) {

var $foscK = parcelRequire("foscK");


module.exports = Promise.all([
    (parcelRequire("gVtzA"))((parcelRequire("3Dw4r")).resolve("cTWR3")),
    $foscK("d7h7m"),
    $foscK("h5bIb")
]).then(()=>parcelRequire("11q0R"));

});
parcelRegister("foscK", function(module, exports) {
"use strict";

function $b34ef9c42c2df185$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("3Dw4r")).resolve(id));
}
module.exports = $b34ef9c42c2df185$var$load;

});

parcelRegister("gVtzA", function(module, exports) {
"use strict";

var $aS0TP = parcelRequire("aS0TP");
module.exports = $aS0TP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRegister("aS0TP", function(module, exports) {
"use strict";
var $7e9fa5252dd49663$var$cachedBundles = {};
var $7e9fa5252dd49663$var$cachedPreloads = {};
var $7e9fa5252dd49663$var$cachedPrefetches = {};
function $7e9fa5252dd49663$var$getCache(type) {
    switch(type){
        case "preload":
            return $7e9fa5252dd49663$var$cachedPreloads;
        case "prefetch":
            return $7e9fa5252dd49663$var$cachedPrefetches;
        default:
            return $7e9fa5252dd49663$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $7e9fa5252dd49663$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("iqHZC", function(module, exports) {

var $foscK = parcelRequire("foscK");
module.exports = Promise.all([
    $foscK("d7h7m"),
    $foscK("fYz2V")
]).then(()=>parcelRequire("5duVz"));

});

var $4e6f033c57c78d44$exports = {};

(parcelRequire("3Dw4r")).register(new URL("", import.meta.url).toString(), JSON.parse('["iQDNm","index.94c88bb6.js","h5bIb","App.b1f8fd79.js","ayuxh","DecodableLogoSmall.97d73fec.svg","7iRlq","AccessNav.9bb4f7fe.js","1WB2L","AccessNav.39e9e262.js","8jIJA","GroupDetailsPage.9a666fcc.js","bqh68","GroupDetailsPage.34990cd8.js","1SCIX","GroupDetailsPage.74258965.js","hMoMy","GroupDetailsPage.54f8b647.js","imqQA","GroupDetailsPage.0f56a079.js","gK9Ud","GroupDetailsPage.6db965f8.js","bkWyz","GroupListingPage.09b3e2d2.js","jCVeS","GroupListingPage.128f2513.js","fDgWP","GroupListingPage.62f8d0e5.js","kgRz6","RoleDetailsPage.3dec46d0.js","hqkHt","RoleListingPage.c13f1da7.js","e1bPM","UserDetailsPage.4a204e3e.js","6sWJb","UserListingPage.94ccf274.js","cKmUq","ConnectionsList.140a5f14.js","8blsc","DecodableSplash.3b8605dc.png","1aNSJ","ConnectionsList.735ec448.js","dwYzh","AstraStreaming.dd08dddb.svg","4T3o5","ClickHouse.7b2ce628.svg","aWTnP","Datadog.d64fb2ed.svg","4Knug","Datagen.99f19553.svg","jsTba","DeltaLake.160b1011.svg","lEg66","Druid.a60adf5d.svg","2XHuv","Kafka.5ee0bb36.svg","ethWd","Kinesis.882948b6.svg","YGSBd","Mongo.a24e29df.svg","aoQqC","MySQL.958abb1a.svg","jyNcq","Oracle.07fff6cd.svg","PkY0a","Pulsar.4a1ab1c7.svg","dcZbQ","Rockset.a4f2fff9.svg","kj5VC","Redis.39cfe7d1.svg","cNLzO","Redpanda.df2f69de.svg","d6d0u","Pinot.cf1e236e.svg","d0wpt","Postgres.d942ac46.svg","4QnUw","Rest.c0ca8b2f.svg","agzwu","S3.557e1f87.svg","fzL7Y","Imply.d3ba79cb.svg","7dcIP","Startree.1f4c3a24.svg","dv2Ys","StreamNative.74a921a4.svg","eIMuH","SingleStore.bbe2bcce.svg","8hhpe","Influx.1c8c7ce3.svg","4lCGV","Elasticsearch.62ccb738.svg","dUEt5","Opensearch.56202687.svg","U3Ant","Hudi.87ee0a21.png","I1Rfe","Iceberg.3d0d4846.png","aKedW","MSSQL.a7aa4094.svg","1YsY2","Snowflake.c0e77415.svg","79lo3","DynamoDB.3cda5fed.svg","hfIez","Redshift.523b545b.svg","iw1sy","PubSub.225ca957.svg","di19w","Confluent.d5c94d9a.svg","4nMI7","QuestionMark.64e7cd87.svg","evxqE","decodable-dark.57a039e6.webp","bm4bJ","ConnectionsList.815346ee.js","7V5iC","ConnectionsList.b6de0664.js","kuAhX","ConnectionsList.fd3b1566.js","jU2Od","ConnectionsList.9442560e.js","2QZhT","ConnectionsList.2a4ec50e.js","gQdJ7","ConnectionsList.831d1712.js","6LPy3","ConnectionsList.81ee2d3e.js","iqPSQ","ConnectionDetails.59b36bd9.js","ip2Z3","ConnectionDetails.f6645c32.js","laLtR","ConnectionDetails.86b09027.js","2pKxJ","ConnectionDetails.bd17fdf0.js","fgx4Y","ConnectionDetails.c4638c35.js","k1DSm","ConnectionDetails.126ce6a3.css","2SIdH","ConnectionCreate.de2df841.js","fNb6i","PipelinesList.9df0d146.js","6lLzE","flink-squirrel.afe25594.webp","g3yBF","decodable-logo-blue.f83334c8.webp","6Uvz0","PipelineDetails.77078e7a.js","6VwLO","PipelineDetails.ab1f1cf8.js","4hTiD","PipelineDetails.df15df01.js","jVtCN","PipelineDetails.538e296e.js","jQ4um","PipelineDetails.731d87c2.css","cKrup","PipelineCreate.12e042e8.js","bUwzS","PipelineUpload.0713b31b.js","b6yfN","FlinkController.c1b3c1ad.js","5zrDU","SecretsList.08df1e2f.js","dZozR","StreamsList.b1aafe60.js","cjAq1","StreamDetails.b64c3cd9.js","ayC1k","StreamDetails.a429b87c.css","7Zcl7","StreamCreate.e1190721.js","amtFu","AccountScopedRoutes.0d7404b1.js","gqWzZ","AccountUpgradePage.4d844f60.js","8dyns","AccountUpgradePage.54be976b.js","9DcyL","InviteCallback.87770bef.js","cGwgD","CliAuthCallback.bef4cd43.js","enIgz","AccountScreen.c70e6bf4.js","dAmWd","HomePage.3387636c.js","oUYKU","decodable-workflow.e37128fb.svg","4srHS","decodable_logo_white.b6ed06d8.svg","jV2L9","AccountListView.32e5bf78.js","d7h7m","App.440d62c0.js","cTWR3","App.f52b77d5.css","fYz2V","bootstrap.e0e4415a.js"]'));


var $dv4VP = parcelRequire("dv4VP");

var $bBjqw = parcelRequire("bBjqw");
const $b856644bbc796336$var$noop = {}; // No-op to change content hash
// Check for UTM query params
new (0, $dv4VP.FirstLoginCampaign)(new (0, $bBjqw.WriteUtmCookiesFromURLSearchParams)()).init();

// In parallel, bootstrap authentication and load the core app bundle.
// This allows us to perform the token exchange while loading the majority
// of the JS needed to start our client-side routing.
const $b856644bbc796336$var$AppPromise = (parcelRequire("c1A2z"));

(parcelRequire("iqHZC")).then(({ bootstrap: bootstrap })=>{
    bootstrap($b856644bbc796336$var$AppPromise);
});


//# sourceMappingURL=index.94c88bb6.js.map
